import type {
  RaspadinhaTimeSlotWinner,
  RaspadinhaWinningTimeSlot,
} from '@/types/raspadinha-campaign'
import type { RaspadinhaCampaign } from '@/types/raspadinha-campaign'
import {
  GARFO_INOX_EXAMPLE_CAMPAIGN_NAME,
  GARFO_INOX_EXAMPLE_CONTENT,
  GARFO_INOX_PRIZE_LABEL,
  getGarfoInoxExampleMediaAndPrizes,
} from './example-garfo-inox-campaign'
import { getDefaultParticipatingCompaniesForCampaign } from './mock-participating-companies'
import { getDefaultParticipantsForCampaign } from './mock-participants'
import { getDefaultRaspadinhaRegulationDocumentFields, DEFAULT_CONTEMPLATED_PRIZE_EXAMPLE_ID } from './default-media-examples'
import { withRaspadinhaExampleCampaignLabel } from './raspadinha-example-label'
import { ensureDateWinningSchedules } from './date-winning-schedules'

type MockTimeSlotInput = {
  id: string
  time: string
  is_active?: boolean
  contemplated_prize_id?: string
  winners?: RaspadinhaTimeSlotWinner[]
}

function buildTimeSlot(input: MockTimeSlotInput): RaspadinhaWinningTimeSlot {
  return {
    id: input.id,
    time: input.time,
    is_active: input.is_active ?? true,
    contemplated_prize_id: input.contemplated_prize_id ?? DEFAULT_CONTEMPLATED_PRIZE_EXAMPLE_ID,
    winners: (input.winners ?? []).map((winner) => ({ ...winner })),
  }
}

function withDateTimes(
  base: ReturnType<typeof ensureDateWinningSchedules>,
  date: string,
  slots: MockTimeSlotInput[]
) {
  return base.map((day) =>
    day.date === date ? { ...day, time_slots: slots.map((slot) => buildTimeSlot(slot)) } : day
  )
}

const garfoInoxMedia = getGarfoInoxExampleMediaAndPrizes()

const GARFO_INOX_STARTS_AT = '2026-06-10T10:00:00.000Z'
const GARFO_INOX_ENDS_AT = '2035-01-01T23:59:00.000Z'

const garfoInoxBaseSchedules = ensureDateWinningSchedules(
  [],
  GARFO_INOX_STARTS_AT,
  GARFO_INOX_ENDS_AT
)

export const MOCK_RASPADINHA_CAMPAIGNS_SEED: RaspadinhaCampaign[] = [
  {
    id: 1,
    name: GARFO_INOX_EXAMPLE_CAMPAIGN_NAME,
    slug: 'raspadinha-garfo-inox',
    status: 'active',
    starts_at: GARFO_INOX_STARTS_AT,
    ends_at: GARFO_INOX_ENDS_AT,
    winning_date_schedules: withDateTimes(
      withDateTimes(garfoInoxBaseSchedules, '2026-06-10', [
        {
          id: 'jun10-1',
          time: '10:00',
          winners: [
            {
              id: 'jun10-1-w1',
              name: 'Ana Silva',
              document: '123.456.789-00',
              prize_label: GARFO_INOX_PRIZE_LABEL,
              notes: withRaspadinhaExampleCampaignLabel(
                'Garfo inox reservado para retirada na loja parceira.'
              ),
            },
          ],
        },
        {
          id: 'jun10-2',
          time: '15:30',
          winners: [
            {
              id: 'jun10-2-w1',
              name: 'Bruno Costa',
              document: '987.654.321-00',
              prize_label: GARFO_INOX_PRIZE_LABEL,
              notes: withRaspadinhaExampleCampaignLabel(
                'Enviar garfo inox para o endereço cadastrado.'
              ),
            },
            {
              id: 'jun10-2-w2',
              name: 'Carla Mendes',
              document: '111.222.333-44',
              prize_label: GARFO_INOX_PRIZE_LABEL,
              notes: withRaspadinhaExampleCampaignLabel('Contemplação registrada no protótipo.'),
            },
          ],
        },
      ]),
      '2026-06-12',
      [
        {
          id: 'jun12-1',
          time: '12:00',
          winners: [],
        },
      ]
    ),
    participants: getDefaultParticipantsForCampaign(1),
    participating_companies: getDefaultParticipatingCompaniesForCampaign(1),
    reading_criteria: [],
    hidden_from_main: false,
    ...GARFO_INOX_EXAMPLE_CONTENT,
    ...garfoInoxMedia,
    regulation_content_type: 'document',
    regulation_text: '',
    ...getDefaultRaspadinhaRegulationDocumentFields(),
    custom_documents: [],
    fb_pixel: '',
    g_pixel: '',
  },
]
